import { emit, events, subscribe } from './eventManager.js';
/**
 * This is a function to close the slideout, either by closing it outright, or hitting the "view cart" button
 * which the consumer of the component can intercept, to hook in custom actions.
 *
 * @param successOrData {boolean | SlideoutCloseData} indicates whether the user closed the cart outright or hit "view cart", or an object with success and cartTotal
 * @param context {string} represents the calling context so that two subscribers can determine if they should handle the event.
 *
 */
function closeSlideout(successOrData, context) {
    // Handle backwards compatibility - if boolean is passed, convert to object format
    const data = typeof successOrData === 'boolean' ? { success: successOrData } : successOrData;
    emit(events.BASE_KIT_SLIDER, data, context);
}
/**
 * Subscribe to the slideout events (user closed the slideout, or user hit view cart)
 *
 * @param callback The callback function to execute when slideout events occur
 * @return function used to unsubscribe from the slideout events
 *
 * @example
 *     subscribeToSlideout(callback)
 */
function subscribeToSlideout(callback) {
    return subscribe(events.BASE_KIT_SLIDER, callback);
}
/**
 * Signal the host page to open the base kit slideout for a given product.
 * The host page (e.g. ODP / HeroEcommerce) should subscribe via
 * `subscribeToOpenSlideout` and create / show the `disw-base-kit-sidebar` element.
 *
 * @param data The product and display information for the slideout to open
 */
function openSlideout(data) {
    emit(events.BASE_KIT_OPEN_SLIDEOUT, data);
}
/**
 * Subscribe to slideout open requests.
 * The callback receives a {@link SlideoutOpenData} object describing which
 * product the slideout should be opened for.
 *
 * @param callback The callback function to execute when an open request occurs
 * @return function used to unsubscribe
 */
function subscribeToOpenSlideout(callback) {
    return subscribe(events.BASE_KIT_OPEN_SLIDEOUT, callback);
}
export default {
    closeSlideout,
    subscribeToSlideout,
    openSlideout,
    subscribeToOpenSlideout,
};
